import { render, staticRenderFns } from "./VFair.vue?vue&type=template&id=6256307d&scoped=true"
import script from "./VFair.vue?vue&type=script&lang=ts"
export * from "./VFair.vue?vue&type=script&lang=ts"
import style0 from "./VFair.vue?vue&type=style&index=0&id=6256307d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256307d",
  null
  
)

export default component.exports